import styled from 'styled-components';

import { Col } from '@thinkific/toga-react';

const wrapped = styled(Col)`
  box-sizing: border-box;
`;

export default wrapped;
